/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ECasePriority = 'Normal' | 'High';

export const ECasePriority = {
    Normal: 'Normal' as ECasePriority,
    High: 'High' as ECasePriority
};

